import { createContext, useContext, type ReactNode } from "react";

type UpdateProjectWorkItemPrefix = (workItemPrefix: string | null) => Promise<void>;

const ProjectWorkItemPrefixUpdateContext = createContext<UpdateProjectWorkItemPrefix | null>(null);

export function ProjectWorkItemPrefixUpdateProvider(props: {
  readonly children: ReactNode;
  readonly onUpdate: UpdateProjectWorkItemPrefix;
}) {
  return (
    <ProjectWorkItemPrefixUpdateContext.Provider value={props.onUpdate}>
      {props.children}
    </ProjectWorkItemPrefixUpdateContext.Provider>
  );
}

export function useProjectWorkItemPrefixUpdate(): UpdateProjectWorkItemPrefix {
  const update = useContext(ProjectWorkItemPrefixUpdateContext);
  if (update === null) {
    throw new Error("ProjectWorkItemPrefixUpdateProvider is required.");
  }
  return update;
}
